import { render, staticRenderFns } from "./PaymentSelectorModal.vue?vue&type=template&id=08a11220&"
import script from "./PaymentSelectorModal.vue?vue&type=script&lang=js&"
export * from "./PaymentSelectorModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSelectorModal.vue?vue&type=style&index=0&id=08a11220&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports